export default {
  examples: [
    { name: 'Apartments from 2009-2010 price per m2', url: 'https://gist.githubusercontent.com/piotrpiatyszek/0129c6dce4c332dccb820b2e709465f3/raw/9644f61d9c977f5c8a4634ad633bb11f65a71efa/data.json' },
    { name: 'FIFA Players Value', url: 'https://gist.githubusercontent.com/piotrpiatyszek/8f93ce2e36adea23a02ceceed0b33882/raw/a1f15984e628c33381b1988e3b7766f1d478d9ab/data.json' },
    { name: 'Employees status classification', url: 'https://gist.githubusercontent.com/piotrpiatyszek/d56bae7c2721e4202eba8454b6d9e5f6/raw/413cecf098f953fc46ca6c4087112b5e73bda505/data.json' }
  ],
  url: 'https://arena.drwhy.ai'
}
